/**
 * DG Footer — Accordion columns on mobile
 * Vanilla JS, no dependencies
 */
(function () {
    'use strict';

    var toggles = document.querySelectorAll('.dg-footer__col-toggle');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var target = document.getElementById(btn.getAttribute('aria-controls'));
            if (!target) return;

            var isOpen = btn.getAttribute('aria-expanded') === 'true';

            // Close all others
            toggles.forEach(function (other) {
                if (other !== btn) {
                    other.setAttribute('aria-expanded', 'false');
                    var otherTarget = document.getElementById(other.getAttribute('aria-controls'));
                    if (otherTarget) otherTarget.classList.remove('is-open');
                }
            });

            // Toggle current
            btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            target.classList.toggle('is-open', !isOpen);
        });
    });

})();
